// extracted by mini-css-extract-plugin
export var actionButton = "_7k-1";
export var actionButtons = "_7k-2";
export var actions = "_7k-0";
export var aiUnread = "_7k-10";
export var alignCenter = "_7k-h";
export var backWrapper = "_7k-3";
export var cellContainer = "_7k-4";
export var checkboxContainer = "_7k-5";
export var contentContainer = "_7k-6";
export var contentHeader = "_7k-8";
export var conversationsTableWrapper = "_7k-s";
export var draftReplyBadgeContainer = "_7k-m";
export var dropdownItem = "_7k-b";
export var dropdownItemsContainer = "_7k-a";
export var dropdownTitle = "_7k-c";
export var errorIcon = "_7k-7";
export var filter = "_7k-d";
export var gray = "_7k-i";
export var headerActionButtons = "_7k-e";
export var headerCheckboxContainer = "_7k-f";
export var icon = "_7k-j";
export var menuContainer = "_7k-k";
export var noMoreTicketsIcon = "_7k-12";
export var noMoreTicketsSubText = "_7k-13";
export var oneLine = "_7k-l";
export var optionsButton = "_7k-n";
export var plus = "_7k-o";
export var portalButtonsWrapper = "_7k-g";
export var red = "_7k-p";
export var scrolledTop = "_7k-9";
export var search = "_7k-q";
export var selectedConversationsCount = "_7k-r";
export var spinner = "_7k-t";
export var strong = "_7k-u";
export var summaryCell = "_7k-v";
export var tableContainer = "_7k-11";
export var tagContainer = "_7k-w";
export var threeDots = "_7k-x";
export var twoLines = "_7k-y";
export var unread = "_7k-z";